import { Box, Typography, Button, Chip } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import VideoCallIcon from "@mui/icons-material/VideoCall";

const UpcomingEvents = ({ event }) => {
    // Etiqueta y color según modalidad
    const modeLabel = {
        "in-person": "Presencial",
        "online": "Online",
        "hybrid": "Híbrido",
    };

    const modeColor = {
        "in-person": "success",
        "online": "primary",
        "hybrid": "secondary",
    };

    const parseDateToLocal = (dateString) => {
        if (!dateString) return null;
      
        const cleanDateString = dateString.split('T')[0];
        const parts = cleanDateString.split('-');
      
        if (parts.length !== 3) return null;
      
        const [year, month, day] = parts.map(Number);
      
        if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
      
        return new Date(year, month - 1, day);
    };
    const localEventDate = event.date ? parseDateToLocal(event.date) : null;

    return (
        <Box 
            className="bg-gray-100 p-4 rounded-lg shadow-md space-y-2 mr-4 ml-2" 
            sx={{ borderLeft: "5px solid #0488AF" }}
        >
            {/* Título del evento */}
            <Typography variant="h6" fontWeight="bold" noWrap>
                {event.title.length > 24 ? `${event.title.substring(0, 24)}...` : event.title}
            </Typography>

            {/* Empresa */}
            {event.business_name && (
                <Typography variant="body2" color="textSecondary">
                    {event.business_name}
                </Typography>
            )}

            {/* Fecha y hora */}
            <Box display="flex" alignItems="center" gap={1}>
                <EventIcon fontSize="small" color="primary" />
                <Typography variant="body2">
                {localEventDate ? localEventDate.toLocaleDateString("es-ES", {
                    weekday: "long",
                    day: "2-digit",
                    month: "long",
                    year: "numeric"
                }).replace(` ${localEventDate.getFullYear()}`, ` ${localEventDate.getFullYear()}`) : ''}
                - {event.hour} hrs
                </Typography>
            </Box>

            {/* Modalidad */}
            {event.mode && (
                <Chip 
                    label={modeLabel[event.mode] || "Otro"} 
                    color={modeColor[event.mode] || "default"} 
                    size="small" 
                />
            )}

            {/* Lugar o link de reunión (según modalidad) */}
            {event.mode === "in-person" && event.place && (
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="body2">{event.place}</Typography>
                </Box>
            )}

            {event.mode === "online" && event.meet_link && (
                <Box display="flex" alignItems="center" gap={1}>
                    <VideoCallIcon fontSize="small" color="action" />
                    <Typography variant="body2">
                        <a 
                            href={event.meet_link} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="text-blue-600 underline"
                        >
                            Unirse a la reunión
                        </a>
                    </Typography>
                </Box>
            )}

            {event.mode === "hybrid" && (
                <>
                    {/* Lugar */}
                    {event.place && (
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="body2">{event.place}</Typography>
                        </Box>
                    )}
                    {/* Link de reunión */}
                    {event.meet_link && (
                        <Box display="flex" alignItems="center" gap={1}>
                            <VideoCallIcon fontSize="small" color="action" />
                            <Typography variant="body2">
                                <a 
                                    href={event.meet_link} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="text-blue-600 underline"
                                >
                                    Unirse a la reunión
                                </a>
                            </Typography>
                        </Box>
                    )}
                </>
            )}

            {/* Botón de inscripción si hay link */}
            {event.registration_link && (
                <Button 
                    variant="contained" 
                    color="primary" 
                    size="small" 
                    fullWidth 
                    sx={{
                        background: 'linear-gradient(to right, #09274A, #0488AF)',
                        color: '#fff',
                        textTransform: 'none',
                        minWidth: 140,
                        minHeight: '36px',
                        padding: '6px 16px',
                        lineHeight: '1.5',
                        '&:hover': {
                            background: 'linear-gradient(to right, #071f3d, #03779C)',
                        },
                    }}
                    href={event.registration_link}
                    target="_blank"
                >
                    Inscribirse
                </Button>
            )}
        </Box>
    );
};

export default UpcomingEvents;
